package com.exura.features.publicplans.domain.usecase

import com.exura.features.plandefinition.domain.model.PlanContentSummary
import com.exura.features.plandefinition.domain.repository.PlanDefinitionRepository
import com.exura.features.plandefinition.usecase.GetTreatmentPlanUseCase
import com.exura.features.publicplans.domain.PublicPlansConstants
import com.exura.features.publicplans.domain.api.ChangeSharedPublicPlanRequest
import com.exura.features.publicplans.domain.api.ChangeSharedPublicPlanResponse
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import dev.gitlive.firebase.functions.FirebaseFunctions

class ReplacePlanDefinitionUseCase(
    private val functions: FirebaseFunctions,
    private val repository: ProviderPublicPlanRepository,
    private val getPlanDefinitionUseCase: GetTreatmentPlanUseCase,
    private val treatmentRepository: PlanDefinitionRepository,
) {
    suspend operator fun invoke(publicPlanId: String, newPlanId: String): Result<Unit> = runCatching {
        val publicEntry = repository.read(publicPlanId).getOrThrow()
        val newPlanVersion = getPlanDefinitionUseCase(id = newPlanId).getOrThrow()
        val callable = functions.httpsCallable(PublicPlansConstants.Functions.GLOBAL_CHANGE_SHARED_PUBLIC_PLAN)

        val response = callable.invoke(
            ChangeSharedPublicPlanRequest(
                globalEntryId = publicEntry.globalEntryId,
                newPlanDefinitionId = newPlanId
            )
        )
        val result = response.data<ChangeSharedPublicPlanResponse>()

        if (result.success) {
            val newSummary = newPlanVersion.getContent(treatmentRepository).summary()
            repository.replacePlanDefinition(
                id = publicPlanId,
                newPlanId = newPlanId,
                newSummary = newSummary,
            ).getOrThrow()
        } else {
            throw Exception(result.message ?: "Failed to replace plan definition")
        }
    }
}
